import { UserId, UserResponse, UserRole } from '@business/entities/account';
import { CommonService } from '@business/services';
import { Endpoint } from '../endpoint';

export function fetchUsers(userRole?: UserRole, isVeryCompact?: boolean, isCompact?: boolean) {
  return Endpoint.get<UserResponse[]>(`@makh/users`, { params: { userRole, isVeryCompact, isCompact } });
}

export function fetchUser(id: UserId) {
  return Endpoint.get<UserResponse>(`@makh/users/user/${id}`);
}

export function fetchEmails(id: UserId) {
  return Endpoint.get<string[]>(`@makh/users/emails/${id}`);
}

export function fetchUserSocials(id: UserId) {
  return Endpoint.get<UserResponse>(`@makh/users/user/${id}`);
}

export function createUser(data: Partial<UserResponse>) {
  return Endpoint.post<UserResponse>(`@makh/users`, { data });
}

export function updateUser(userId: UserId, data: Partial<UserResponse>) {
  return Endpoint.patch<UserResponse>(`@makh/users/${userId}`, { data });
}

export function changePassword(userId: UserId, password: string) {
  return Endpoint.patch<UserResponse>(`@makh/users/change-password/${userId}`, { data: { password } });
}

export function deleteUser(userId: UserId, otherUser?: UserId, parentIds?: UserId[], childUserIds?: UserId[]) {
  if (otherUser) {
    return Endpoint.delete<void>(`@makh/users/user/${userId}`, { data: { otherUser, parentIds, childUserIds } });
  }
  return Endpoint.delete<void>(`@makh/users/${userId}`);
}

export function uploadImage(id: UserId, data: File) {
  const formData = CommonService.toFormData({ image: data });
  return Endpoint.post<UserResponse>(`@makh/users/update-avatar/${id}`, { formData, hasFiles: true });
}

export function fetchStripe() {
  return Endpoint.get<UserResponse>(`@makh/stripe/customer-transaction-history?customerId=cus_RtAwzjnEMGLyLQ`);
}
